var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cp-main",class:_vm.loggedIn ? 'header-top' : ''},[_c('HeaderComponent'),_c('CustomMenu'),_c('transition',[_c('div',{staticClass:"min-height"},[_c('router-view')],1)]),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }